import { render, staticRenderFns } from "./LogFilesTab.vue?vue&type=template&id=c6fb05c0&scoped=true&"
import script from "./LogFilesTab.vue?vue&type=script&lang=js&"
export * from "./LogFilesTab.vue?vue&type=script&lang=js&"
import style0 from "./LogFilesTab.vue?vue&type=style&index=0&id=c6fb05c0&prod&lang=scss&scoped=true&"
import style1 from "./LogFilesTab.vue?vue&type=style&index=1&id=c6fb05c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fb05c0",
  null
  
)

export default component.exports